import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as nls from '../../../nls.js';
import { alert } from '../../../base/browser/ui/aria/aria.js';
import { EditorAction, registerEditorAction } from '../../browser/editorExtensions.js';
import { TabFocus } from '../../common/config/commonEditorConfig.js';
export var ToggleTabFocusModeAction = /*#__PURE__*/function (_EditorAction) {
  _inherits(ToggleTabFocusModeAction, _EditorAction);

  var _super = _createSuper(ToggleTabFocusModeAction);

  function ToggleTabFocusModeAction() {
    _classCallCheck(this, ToggleTabFocusModeAction);

    return _super.call(this, {
      id: ToggleTabFocusModeAction.ID,
      label: nls.localize({
        key: 'toggle.tabMovesFocus',
        comment: ['Turn on/off use of tab key for moving focus around VS Code']
      }, "Toggle Tab Key Moves Focus"),
      alias: 'Toggle Tab Key Moves Focus',
      precondition: undefined,
      kbOpts: {
        kbExpr: null,
        primary: 2048
        /* CtrlCmd */
        | 43
        /* KEY_M */
        ,
        mac: {
          primary: 256
          /* WinCtrl */
          | 1024
          /* Shift */
          | 43
          /* KEY_M */

        },
        weight: 100
        /* EditorContrib */

      }
    });
  }

  _createClass(ToggleTabFocusModeAction, [{
    key: "run",
    value: function run(accessor, editor) {
      var oldValue = TabFocus.getTabFocusMode();
      var newValue = !oldValue;
      TabFocus.setTabFocusMode(newValue);

      if (newValue) {
        alert(nls.localize('toggle.tabMovesFocus.on', "Pressing Tab will now move focus to the next focusable element"));
      } else {
        alert(nls.localize('toggle.tabMovesFocus.off', "Pressing Tab will now insert the tab character"));
      }
    }
  }]);

  return ToggleTabFocusModeAction;
}(EditorAction);
ToggleTabFocusModeAction.ID = 'editor.action.toggleTabFocusMode';
registerEditorAction(ToggleTabFocusModeAction);